



















































import Component from 'vue-class-component'
import Vue from 'vue'
import { ToolbarLink } from 'vue-kit'
import LayoutStore from '@/stores/LayoutStore'
import { Routes } from '@/router/routes'
import { Watch } from 'vue-property-decorator'
import UserMenu from '@/components/UserMenu.vue'

const userHistoryComponent = () =>
  import(
    /* webpackChunkName: "user_history" */ '../components/history/UserHistory.vue'
  )

const calculatorComponent = () =>
  import(
    /* webpackChunkName: "calculator" */ '../components/calculator/Calculator.vue'
  )

@Component({ components: { UserMenu } })
export default class DefaultLayout extends Vue {
  layoutStore = LayoutStore

  links: ToolbarLink[] = [
    { route: { name: Routes.limits }, label: 'Таможенные лимиты' },
    { route: { name: Routes.priceConfigs }, label: 'Веса и цены' },
    { route: { name: Routes.taxes }, label: 'Таможенные сборы' },
    { route: { name: Routes.stats }, label: 'Статистика' },
  ]

  get isShowRightSidebar(): boolean {
    return this.layoutStore.rightSidebarComponent !== null
  }

  get isShowHistory(): boolean {
    return this.layoutStore.rightSidebarComponent === userHistoryComponent
  }

  get isShowCalculator(): boolean {
    return this.layoutStore.rightSidebarComponent === calculatorComponent
  }

  showHistory() {
    this.layoutStore.setRightSidebarComponent(
      this.isShowHistory ? null : userHistoryComponent
    )
  }

  showCalculator() {
    this.layoutStore.setRightSidebarComponent(
      this.isShowCalculator ? null : calculatorComponent
    )
  }

  @Watch('layoutStore.isShowRightSidebar')
  resetRightSidebarComponent(isShowSidebar: boolean) {
    if (!isShowSidebar) {
      this.layoutStore.setRightSidebarComponent(null)
    }
  }
}
